import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheckCircle, FiMapPin, FiUsers } from "react-icons/fi";
import ScrollReveal from "./ScrollReveal.jsx";

export default function HomePreviewConversion() {
  return (
    <section id="preview-banquet-cta" className="bg-zoom-warm py-20 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <ScrollReveal className="relative isolate overflow-hidden rounded-[32px] border border-zoom-emerald/10 bg-[linear-gradient(135deg,#0A3D3A_0%,#0B2A26_68%,#173414_100%)] p-6 shadow-hp-dark sm:p-8 lg:p-12">
          <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-zoom-gold/10 blur-3xl" />
          <div className="grid gap-9 lg:grid-cols-[1fr_0.9fr] lg:items-center">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-zoom-goldSoft">Banquet Discovery</p>
              <h2 className="font-display mt-4 text-3xl font-bold tracking-tight sm:text-[44px] sm:leading-tight">Search Banquet</h2>
              <p className="mt-5 max-w-2xl text-base font-normal leading-8 text-white/84">
                Find verified banquet options near you for birthdays, baby showers, weddings, and family events.
                Minimum 50 guests, with quick DecorZoom support for shortlisting and next steps.
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/banquets"
                  className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-zoom-goldSoft px-6 py-3 text-sm font-semibold text-zoom-emeraldDeep shadow-hp-gold transition hover:-translate-y-0.5 hover:bg-white"
                >
                  Search Banquets <FiArrowRight aria-hidden="true" />
                </Link>
                <a
                  href="#preview-gallery"
                  className="inline-flex min-h-[52px] items-center justify-center rounded-full border border-white/25 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-white/10"
                >
                  View Recent Work
                </a>
              </div>
              <p className="mt-4 text-xs font-semibold uppercase tracking-[0.16em] text-zoom-goldSoft">
                Starting from Rs. 750 per person* | *Terms & Conditions Apply
              </p>
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
              {[
                [<FiUsers aria-hidden="true" />, "50+", "Minimum Guest"],
                [<FiCheckCircle aria-hidden="true" />, "Rs. 750", "Starting Per Person*"],
                [<FiMapPin aria-hidden="true" />, "Delhi NCR", "Venue Coverage"],
                [<FiArrowRight aria-hidden="true" />, "Fast", "Search Banquets CTA"],
              ].map(([icon, value, label]) => (
                <div
                  key={label}
                  className="hp-glass-dark rounded-3xl p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] transition duration-300 hover:-translate-y-1"
                >
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/12 text-zoom-goldSoft">
                    {icon}
                  </span>
                  <p className="font-display mt-5 text-3xl font-bold text-white">{value}</p>
                  <p className="mt-2 text-sm font-medium leading-6 text-white/82">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
